import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {  IonRouterOutlet } from '@ionic/angular/standalone';

@Component({
  selector: 'app-kids',
  templateUrl: './kids.page.html',
  styleUrls: ['./kids.page.scss'],
  standalone: true,
  imports: [IonRouterOutlet, RouterModule, CommonModule, FormsModule]
})
export class KidsPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
